export const META_TYPE = 'fileLister';
export const META_VER = 'v1';

export const CMD_FILELISTER_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
